import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTachometerAlt as faTachometerAltSolid,
  faFolder as faFolderSolid,
  faLockOpen as faLockOpenSolid,
  faBell as faBellSolid,
  faEye as faEyeSolid,
  faUpload as faUploadSolid,
  faUser as faUserSolid,
  faUserFriends as faUserFriendsSolid,
  faUserPlus as faUserPlusSolid,
  faUserEdit as faUserEditSolid,
  faUserTimes as faUserTimesSolid,
  faTasks as faTasksSolid,
  faMapMarkerAlt as faMapMarkerAltSolid,
  faCog as faCogSolid,
  faKey as faKeySolid,
  faBook as faBookSolid,
  faUsers as faUsersSolid,
  faPenSquare as faPenSquareSolid,
  faBars as faBarsSolid,
  faPlusSquare as faPlusSquareSolid,
  faInfoCircle as faInfoCircleSolid,
  faEuroSign as faEuroSignSolid,
  faAsterisk as faAsteriskSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faAddressCard as faAddressCardSolid,
  faShareAltSquare as faShareAltSquareSolid,
  faFlag as faFlagSolid,
  faGlobeAmericas as faGlobeAmericasSolid,
  faComments as faCommentsSolid,
  faComment as faCommentSolid,
  faPhoneAlt as faPhoneAltSolid,
  faWrench as faWrenchSolid,
  faDoorClosed as faDoorClosedSolid,
} from '@fortawesome/free-solid-svg-icons';
import {
  faChartBar as faChartBarRegular,
  faCalendarAlt as faCalendarAltRegular,
  faClock as faClockRegular,
  faFolder as faFolderRegular,
  faBuilding as faBuildingRegular,
  faDotCircle as faDotCircleRegular,
  faMap as faMapRegular,
  faEnvelope as faEnvelopeRegular,
  faListAlt as faListAltRegular,
} from '@fortawesome/free-regular-svg-icons';

import { faFacebookSquare as faFacebookSquareBrand } from '@fortawesome/free-brands-svg-icons';

library.add(
  faChartBarRegular,
  faCalendarAltRegular,
  faClockRegular,
  faFolderRegular,
  faBuildingRegular,
  faDotCircleRegular,
  faMapRegular,
  faEnvelopeRegular,
  faListAltRegular,
  faTachometerAltSolid,
  faFolderSolid,
  faLockOpenSolid,
  faBellSolid,
  faEyeSolid,
  faUploadSolid,
  faUserSolid,
  faUserFriendsSolid,
  faUserPlusSolid,
  faUserEditSolid,
  faUserTimesSolid,
  faTasksSolid,
  faMapMarkerAltSolid,
  faCogSolid,
  faKeySolid,
  faBookSolid,
  faUsersSolid,
  faPenSquareSolid,
  faBarsSolid,
  faPlusSquareSolid,
  faInfoCircleSolid,
  faEuroSignSolid,
  faAsteriskSolid,
  faExclamationTriangleSolid,
  faAddressCardSolid,
  faShareAltSquareSolid,
  faFlagSolid,
  faGlobeAmericasSolid,
  faCommentsSolid,
  faCommentSolid,
  faPhoneAltSolid,
  faWrenchSolid,
  faDoorClosedSolid,
  faFacebookSquareBrand
);

export default library;
